import React, { useEffect, useState } from 'react';
import api from '../../../services/api';

export const simpayMethodTitle = code => ({ applepay: 'Apple Pay', cashapp: 'Cash App', cashapplt: 'Cash App Lite', googlepay: 'Google Pay', chime: 'Chime' }[code] || code || 'Payment');

export default function SimpayPaymentLinks({ onOpen }) {
  const [payments, setPayments] = useState([]);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(null);
  const [revision, setRevision] = useState(0);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api.get(`/api/simpay/payins?offset=${offset}`).then(res => {
      if (!cancelled) { setPayments(res.data?.payments || []); setHasMore(Boolean(res.data?.has_more)); setError(''); }
    }).catch(() => { if (!cancelled) setError('Could not load payment history. Existing links remain tracked.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [revision, offset]);
  const open = async payment => {
    if (busy) return;
    setBusy(payment.order_id);
    try {
      const result = await api.get(`/api/simpay/payins/${encodeURIComponent(payment.order_id)}`);
      onOpen(result.data);
    } catch { setError('Could not check this payment. No new payment was created.'); }
    finally { setBusy(null); }
  };
  return <section className="rounded-xl bg-white p-4 text-slate-900" data-testid="simpay-payment-history">
    <div className="flex justify-between gap-3">
      <h3 className="font-bold">Your payment links</h3>
      <button type="button" disabled={loading} className="underline text-sm" onClick={() => { setOffset(0); setRevision(n => n + 1); }}>Refresh links</button>
    </div>
    <p className="text-sm mt-2">Each link is checked for up to 15 minutes from creation. Unpaid links do not block a different method or amount. Later verified payment notifications still count. Pay only the links you intend to deposit.</p>
    {error && <p role="status" className="text-sm text-amber-800 mt-2">{error}</p>}
    {loading && <p role="status" className="text-sm mt-2">Loading payment links…</p>}
    {!loading && !payments.length && !error && <p className="text-sm mt-2">No payment links yet.</p>}
    <div className="max-h-64 overflow-y-auto mt-3 space-y-2">
      {payments.map(payment => <div key={payment.order_id} className="border rounded-lg p-3 flex justify-between gap-2 items-center">
        <div>
          <p className="font-bold">{simpayMethodTitle(payment.method)} · ${Number(payment.charged_amount).toFixed(2)}</p>
          <p className="text-xs">{payment.manual_review ? 'Manual review' : payment.status === 'APPROVED' ? 'Paid · credited' : payment.status === 'FAILED' ? 'Not completed' : payment.polling?.stopped ? '15-minute checking ended · unconfirmed' : 'Awaiting payment / confirmation'}</p>
          <p className="text-xs break-all">Order {payment.order_id}</p>
        </div>
        <button type="button" disabled={Boolean(busy)} className="underline text-sm shrink-0" onClick={() => open(payment)}>
          {busy === payment.order_id ? 'Checking…' : payment.polling?.stopped ? 'View' : 'View / Check'}
        </button>
      </div>)}
    </div>
    {(offset > 0 || hasMore) && <div className="flex justify-between mt-3">
      <button type="button" disabled={loading || offset === 0} onClick={() => setOffset(n => Math.max(0, n - 50))}>Newer links</button>
      <button type="button" disabled={loading || !hasMore} onClick={() => setOffset(n => n + 50)}>Older links</button>
    </div>}
  </section>;
}
